<div class="container-fluid px-5 py-3">
    <div class="d-flex justify-content-between pb-2">
        <span class="text-blue font-weight-bold">
            <h3 class="my-2" translate>listSmsCampaign.title</h3>
        </span>
    </div>

    <div class="my-2 py-2">
        <!-- Search Form -->
        <form [formGroup]="searchForm">
            <div class="input-group mb-2">
                <!-- name search -->
                <div class="input-group-prepend">
                    <span class="input-group-text" translate>listSmsCampaign.name</span>
                </div>
                <input type="text" class="form-control d-inline" (keyup.enter)="search()" formControlName="name">

                <!-- technical point filter -->
                <div class="input-group-prepend ml-2">
                    <span class="input-group-text" translate>listSmsCampaign.technicalPoint</span>
                </div>
                <select class="custom-select input-custom-size" formControlName="technicalPointMobileAppId">
                    <option [ngValue]="null" translate>placeholder.select</option>
                    <option *ngFor="let technicalPoint of technicalPoints" [ngValue]="technicalPoint.mobileAppId">
                        {{technicalPoint.name}}
                    </option>
                </select>

                <!-- status filter -->
                <div class="input-group-prepend ml-2">
                    <span class="input-group-text" translate>listSmsCampaign.status</span>
                </div>
                <select class="custom-select input-custom-size" formControlName="isActive">
                    <option [ngValue]="null" translate>placeholder.select</option>
                    <option [ngValue]="true" translate>listSmsCampaign.active</option>
                    <option [ngValue]="false" translate>listSmsCampaign.inactive</option>
                </select>

                <!-- incoming way filter -->
                <div class="input-group-prepend ml-2">
                    <span class="input-group-text" translate>listSmsCampaign.incomingWay</span>
                </div>
                <select class="custom-select input-custom-size" formControlName="incomingWay">
                    <option [ngValue]="null" translate>placeholder.select</option>
                    <option *ngFor="let way of incomingWays" [ngValue]="way.code">{{way.nameKey | translate}}</option>
                </select>

                <!-- actions -->
                <div class="input-group-prepend ml-2">
                    <div style="display: flex;">
                        <button class="btn btn-outline-success" style="border-radius: 0;" type="button" (click)="search()" translate>button.search</button>
                        <button class="btn btn-outline-danger ml-2" style="border-radius: 0;" type="button" (click)="clearSearch()" translate>button.clear</button>
                        <button class="btn btn-outline-success ml-2" style="border-radius: 0;" routerLink="/add-edit-sms-campaign" type="button"
                                *ngIf="perms.hasAccess(perms.CAN_ADD_EDIT_SMS_CAMPAIGN_CONFIG)" translate>button.add</button>
                    </div>
                </div>
            </div>
        </form>

        <br>

        <!-- Table -->
        <div class="d-flex justify-content-center">
            <table class="table table-bordered table-striped w-100" [hidden]="!dataLoaded">
                <thead>
                    <tr>
                        <th translate>listSmsCampaign.name</th>
                        <th translate>listSmsCampaign.status</th>
                        <th translate>listSmsCampaign.technicalPoints</th>
                        <th translate>listSmsCampaign.notificationTime</th>
                        <th translate>listSmsCampaign.incomingWays</th>
                        <th translate>listSmsCampaign.actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let config of content">
                        <td>{{config.name}}</td>
                        <td>
                            <span *ngIf="config.isActive" translate>listSmsCampaign.active</span>
                            <span *ngIf="!config.isActive" translate>listSmsCampaign.inactive</span>
                        </td>
                        <td>{{technicalPointNames(config)}}</td>
                        <td>{{config.notificationTime}}</td>
                        <td>{{incomingWayLabels(config)}}</td>
                        <td class="text-center py-2">
                            <button class="btn btn-sm btn-success" routerLink="/add-edit-sms-campaign"
                                *ngIf="perms.hasAccess(perms.CAN_ADD_EDIT_SMS_CAMPAIGN_CONFIG)"
                                data-toggle="tooltip" data-placement="bottom" title="{{'button.edit' | translate}}"
                                [queryParams]="{id: config.id}">
                                <i class="fa fa-pencil fa-lg"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <ng-container *ngIf="dataLoaded; else dataLoadingTemplate"></ng-container>

        <!-- Pagination -->
        <div class="paging-wrapper d-flex justify-content-between">
            <select class="pagination-size custom-select" [(ngModel)]="sortingPaging.pageSize" [ngModelOptions]="{standalone: true}" (change)="onPageSizeChange($event)">
                <option *ngFor="let item of pageSizeOptions; let i = index" [value]="pageSizeOptions[i]">
                    {{pageSizeOptions[i]}} {{'paging.itemsPerPage' | translate}}
                </option>
            </select>
            <ngb-pagination class="pagination-control"
                [(page)]="sortingPaging.pageNumber"
                [pageSize]="sortingPaging.pageSize"
                [collectionSize]="sortingPaging.totalElements"
                [boundaryLinks]="true"
                [maxSize]="maxSize"
                (pageChange)="pageChanged($event)">
            </ngb-pagination>
            <span class="pagination-index border center">
                {{sortingPaging.fromRow}} - {{sortingPaging.toRow}} / {{sortingPaging.totalElements}}
            </span>
        </div>
    </div>
</div>

<ng-template #dataLoadingTemplate>
    <div *ngIf="errorMessage$ | async as errorMessage; else dataSpinner">
        <div class="alert alert-danger">
            {{errorMessage}}
        </div>
        <div class="d-flex justify-content-center">
            <i class="fa fa-refresh" (click)="reload()"></i>
        </div>
    </div>
    <ng-template #dataSpinner>
        <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </ng-template>
</ng-template>
